const skew = {
  name: "skew",
  path: "/skew",
  title: "skew",
  description: "Utilities for controlling skew transforms.",
  value: {
    "transform": {
      "skew-<number>": "skewX(<number>deg) skewY(<number>deg)",
      "-skew-<number>": "skewX(-<number>deg) skewY(-<number>deg)",
      "skew-x-<number>": "skewX(<number>deg)",
      "-skew-x-<number>": "skewX(-<number>deg)",
      "skew-y-<number>": "skewY(<number>deg)",
      "-skew-y-<number>": "skewY(-<number>deg)"
    }
  },
  exampleData: [
    {
      example: {
        code: `<img class="skew-3 ..." src="/img/mountains.jpg" />
<img class="skew-6 ..." src="/img/mountains.jpg" />
<img class="skew-12 ..." src="/img/mountains.jpg" />`
      }
    },
    {
      example: {
        code: `<img class="-skew-3 ..." src="/img/mountains.jpg" />
<img class="-skew-6 ..." src="/img/mountains.jpg" />
<img class="-skew-12 ..." src="/img/mountains.jpg" />`
      }
    },
    {
      example: {
        code: `<img class="-skew-x-12 ..." src="/img/mountains.jpg" />
<img class="skew-x-6 ..." src="/img/mountains.jpg" />
<img class="skew-x-12 ..." src="/img/mountains.jpg" />`
      }
    },
    {
      example: {
        code: `<img class="-skew-y-12 ..." src="/img/mountains.jpg" />
<img class="skew-y-6 ..." src="/img/mountains.jpg" />
<img class="skew-y-12 ..." src="/img/mountains.jpg" />`
      }
    },
  ],
  htmlData: [
    {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">skew-<var>&lt;number&gt;</var></code> utilities like <code class="text-color-blue-500">skew-3</code> and <code class="text-color-blue-500">skew-6</code> to skew an element:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">skew-3</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-3 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">skew-6</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-6 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">skew-12</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-12 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
    {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">-skew-<var>&lt;number&gt;</var></code> utilities like <code class="text-color-blue-500">-skew-3</code> and <code class="text-color-blue-500">-skew-6</code> to skew an element:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">-skew-3</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-skew-3 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">-skew-6</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-skew-6 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">-skew-12</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-skew-12 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">skew-x-<var>&lt;number&gt;</var></code> utilities like <code class="text-color-blue-500">skew-x-3</code> and <code class="text-color-blue-500">skew-x-6</code> to skew an element:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">-skew-x-12</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-skew-x-12 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">skew-x-6</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-x-6 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">skew-x-12</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-x-12 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
        {
            data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-6">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">skew-y-<var>&lt;number&gt;</var></code> utilities like <code class="text-color-blue-500">skew-y-3</code> and <code class="text-color-blue-500">skew-y-6</code> to skew an element:
      </p>
      <div class="flex gap-8 items-end mb-6 justify-around">
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">-skew-y-12</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="-skew-y-12 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">skew-y-6</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-y-6 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
        <div class="flex flex-col items-center">
          <span class="mb-8 text-xs text-color-gray-500">skew-y-12</span>
          <div class="relative">
            <div class="absolute inset-0">
              <img class="size-32 opacity-25 rounded-lg object-cover opacity-25" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo"/>
            </div>
            <img class="skew-y-12 size-32 rounded-lg shadow-lg" src="https://fastly.picsum.photos/id/866/600/600.jpg?hmac=dKQ662qAsYvwCo90SUl-0iG9K0Yp3ySEK0wJVIYh5uo" alt="mountains" />
          </div>
        </div>
      </div>
      `
        },
  ]
};

export default skew;
<div className="skew-3 skew-6 skew-12 -skew-3 -skew-6 -skew-12 -skew-x-12 skew-x-6 skew-x-12 -skew-y-12 skew-y-6 skew-y-12"></div>